import { PartialStateUpdater } from '@ngrx/signals';
import { immutableUpdate } from 'src/app/shared/utils/global.utils';
import { ISidebarState } from '../model/sidebar-state.model';

export function searchStringSetter(
  searchString: ISidebarState['searchString']
): PartialStateUpdater<ISidebarState> {
  return (state) =>
    immutableUpdate(state, { searchString: { $set: searchString } });
}

export function taskTypesSelectionSetter(
  taskTypesSelection: ISidebarState['taskTypesSelection']
): PartialStateUpdater<ISidebarState> {
  return (state) =>
    immutableUpdate(state, {
      taskTypesSelection: { $set: taskTypesSelection },
    });
}

export function taskOwnershipSetter(
  taskOwnership: ISidebarState['taskOwnership']
): PartialStateUpdater<ISidebarState> {
  return (state) =>
    immutableUpdate(state, { taskOwnership: { $set: taskOwnership } });
}

export function activeTabSetter(
  activeTab: ISidebarState['activeTab']
): PartialStateUpdater<ISidebarState> {
  return (state) => immutableUpdate(state, { activeTab: { $set: activeTab } });
}

export function collapsedSetter(
  collapsed: ISidebarState['collapsed']
): PartialStateUpdater<ISidebarState> {
  return (state) => immutableUpdate(state, { collapsed: { $set: collapsed } });
}
